import { Message, MessageBox } from 'element-ui'
import VueI18n from '../i18n/i18n'
let $I18n = VueI18n
// $I18n.t('timeArr.Just_now')

let errorMessage = function(err){
	console.log(err)
	if(err.code == 4001){
		return //未登录
	}else{
		Message($I18n.t('tipsArr.System_Error'), 'error')
	}
}

export default errorMessage